import palette from '@lib/core/src/theme/palette';
import { Menu, MenuItem, styled, Typography } from '@mui/material';
import { RiSettings5Line, RiSkipRightLine } from '@remixicon/react';

import useLoginContext from '@/context/LoginFlowContextProvider/useLoginContext';

export const ActionTitle = styled(Typography)({
  paddingLeft: '10px',
  fontSize: '12px',
  color: palette.menu.item,
  fontWeight: 400
});

export const Name = styled(Typography)({
  fontSize: '14px',
  fontWeight: 700
});

export const Email = styled(Typography)({
  fontSize: '13px',
  color: palette.common.label
});

const UserMenu = ({
  anchorEl,
  setAnchorEl,
  openPersonalSeetings
}: {
  anchorEl: HTMLElement | undefined;
  setAnchorEl: (anchorEl: HTMLElement | undefined) => void;
  openPersonalSeetings: () => void;
}) => {
  const handleClose = () => {
    setAnchorEl(undefined);
  };

  const { signOut } = useLoginContext();

  return (
    <Menu
      slotProps={{
        paper: {
          sx: {
            ml: -3,
            mt: -3,
            width: anchorEl?.clientWidth,
            borderRadius: '8px',
            boxShadow:
              '0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08)'
          }
        },
        list: {
          sx: {
            padding: 0
          }
        }
      }}
      className="user-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      onClick={handleClose}
      anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
    >
      <MenuItem
        onClick={() => {
          openPersonalSeetings();
          handleClose();
        }}
      >
        <RiSettings5Line size={16} />
        <ActionTitle>Personal Settings</ActionTitle>
      </MenuItem>
      <MenuItem onClick={() => signOut()}>
        <RiSkipRightLine size={16} color={palette.red[300]} />
        <ActionTitle sx={{ color: palette.red[300] }}>Sign out</ActionTitle>
      </MenuItem>
    </Menu>
  );
};

export default UserMenu;
